import { FormProvider } from "react-hook-form"
import { AddCustomEquipment } from "./components/AddCustomEquipment"
import { AddCustomEquipmentSkeleton } from "./components/AddCustomEquipmentSkeleton"
import type { RichCustomEquipment } from "./useAddCustomEquipment"
import { useAddCustomEquipment } from "./useAddCustomEquipment"

interface AddCustomEquipmentContainerProps {
	onAddCustomEquipment: (customEquipment: RichCustomEquipment) => Promise<void> | void
	onFormClosed?: () => void
}

export const AddCustomEquipmentContainer = ({
	onAddCustomEquipment,
	onFormClosed,
}: AddCustomEquipmentContainerProps) => {
	const { form, onSubmit, props } = useAddCustomEquipment({
		onAddCustomEquipment,
		onFormClosed,
	})
	return props ? (
		<FormProvider {...form}>
			<form onSubmit={form.handleSubmit(onSubmit)} noValidate>
				<AddCustomEquipment {...props} />
			</form>
		</FormProvider>
	) : (
		<AddCustomEquipmentSkeleton />
	)
}
